import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/**
 * Command-palette items + ranking. Pure and testable: the component feeds
 * store snapshots in and gets an ordered, sectioned list back.
 *
 * "Smart" ranking, honestly earned from pack data: with an empty query the
 * Suggested order surfaces what matters (failed tests first, then the
 * failure jump, tabs, actions); with a query, fuzzy scores combine with
 * intent boosts ("fail" pulls failed tests up, "network" pulls the HAR
 * tab, TC-ids match directly).
 */

import { downloadPack, harRefsFor, openIssueDrawer, readPackBytes, selectDetailStep, setDetailDrawer, setDetailLogsSub } from '../../data/pack-store';
import { aspectNames, isInvariant, uniqueSources } from '../../model/coverage';
import { requestCoverageFocus } from '../Coverage/coverage-focus';
import { closeDetailInPlace, closeDetailWithUrl, openDetailWithUrl } from '../../app/url-sync';
import { issueTypeFromCategory } from '../../model/issue-type';
import { truncateMiddle } from '../format';
import { fuzzyScore } from './fuzzy';
var STATUS_PRIORITY = {
  failed: 90,
  broken: 82,
  unknown: 45,
  skipped: 42,
  passed: 40
};
/** Blob download for a pack entry (palette's per-source action). */
function downloadSourceEntry(_x, _x2) {
  return _downloadSourceEntry.apply(this, arguments);
}
/** Uncovered use-cases float above partial above covered — mirror of the
 * failed-first ordering for tests. Display strings only, no score math. */
function _downloadSourceEntry() {
  _downloadSourceEntry = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(rel, name) {
    var bytes, url, a;
    return _regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 1;
          return readPackBytes(rel)["catch"](function () {
            return null;
          });
        case 1:
          bytes = _context.sent;
          if (bytes) {
            _context.next = 2;
            break;
          }
          return _context.abrupt("return");
        case 2:
          url = URL.createObjectURL(new Blob([bytes]));
          a = document.createElement('a');
          a.href = url;
          a.download = name;
          a.click();
          setTimeout(function () {
            return URL.revokeObjectURL(url);
          }, 1000);
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _downloadSourceEntry.apply(this, arguments);
}
var UC_STATUS_PRIORITY = {
  uncovered: 66,
  partial: 56,
  covered: 46
};
export function buildPaletteItems(ctx) {
  var _attention$items;
  var rowIds = ctx.rowIds,
    rows = ctx.rows,
    detail = ctx.detail,
    attention = ctx.attention,
    coverage = ctx.coverage,
    goTab = ctx.goTab;
  var items = [];

  // Lateral navigation: close in place — closeDetailWithUrl's async
  // history.back() would let popstate clobber the tab we're jumping to.
  var leaveDetail = function leaveDetail() {
    if (detail) closeDetailInPlace();
  };

  // ── Jump to (tabs) ──
  var tabs = [{
    key: 'report',
    label: 'Go to Report',
    keywords: 'summary pass rate attention'
  }, {
    key: 'instances',
    label: 'Go to Test Instances',
    keywords: 'tests list all'
  }, {
    key: 'issues',
    label: 'Go to Issues',
    keywords: 'bugs'
  }, {
    key: 'coverage',
    label: 'Go to Coverage',
    keywords: 'use cases acceptance criteria verified rollup'
  }];
  var _loop = function _loop() {
    var t = _tabs[_i];
    items.push({
      id: "tab:".concat(t.key),
      kind: 'tab',
      section: 'Jump to',
      label: t.label,
      hint: 'tab',
      keywords: t.keywords,
      priority: 70,
      run: function run() {
        leaveDetail();
        goTab(t.key);
      }
    });
  };
  for (var _i = 0, _tabs = tabs; _i < _tabs.length; _i++) {
    _loop();
  }

  // ── Tests ──
  var _iterator = _createForOfIteratorHelper(rowIds),
    _step;
  try {
    var _loop5 = function _loop5() {
      var _row$testcaseId, _STATUS_PRIORITY$row$;
      var id = _step.value;
      var row = rows.get(id);
      if (!row || row.state !== 'loaded') return 1; // continue
      // Display truncated (no "TC-" prefix — packs carry only the raw ULID);
      // keywords keep the FULL id so searching by any fragment still matches.
      var tc = row.testcaseId ? truncateMiddle(row.testcaseId, 15) : null;
      items.push({
        id: "test:".concat(id),
        kind: 'test',
        section: 'Tests',
        label: tc ? "Open ".concat(tc, " \xB7 ").concat(row.title) : "Open ".concat(row.title),
        hint: row.status === 'unknown' ? '' : row.status,
        status: row.status,
        keywords: "".concat(id, " ").concat((_row$testcaseId = row.testcaseId) !== null && _row$testcaseId !== void 0 ? _row$testcaseId : '', " ").concat(row.status),
        priority: ((_STATUS_PRIORITY$row$ = STATUS_PRIORITY[row.status]) !== null && _STATUS_PRIORITY$row$ !== void 0 ? _STATUS_PRIORITY$row$ : 40) + ((detail === null || detail === void 0 ? void 0 : detail.testId) === id ? -20 : 0),
        // the open one is less useful
        run: function run() {
          return openDetailWithUrl(id);
        }
      });
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      if (_loop5()) continue;
    }

    // ── Issues (pack failure records → the RCA drawer) ──
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  var _iterator2 = _createForOfIteratorHelper(((_attention$items = attention === null || attention === void 0 ? void 0 : attention.items) !== null && _attention$items !== void 0 ? _attention$items : []).entries()),
    _step2;
  try {
    var _loop6 = function _loop6() {
      var _issue$ordinal, _issue$status, _issue$category;
      var _step2$value = _slicedToArray(_step2.value, 2),
        i = _step2$value[0],
        issue = _step2$value[1];
      items.push({
        id: "issue:".concat(issue.testId, ":").concat((_issue$ordinal = issue.ordinal) !== null && _issue$ordinal !== void 0 ? _issue$ordinal : i),
        kind: 'issue',
        section: 'Issues',
        label: "Open issue \xB7 ".concat(issue.title),
        hint: issueTypeFromCategory(issue.category).label.toLowerCase(),
        status: (_issue$status = issue.status) !== null && _issue$status !== void 0 ? _issue$status : 'failed',
        keywords: "rca root cause bug ".concat(issue.testId, " ").concat((_issue$category = issue.category) !== null && _issue$category !== void 0 ? _issue$category : ''),
        priority: 88,
        // just under failed tests — the pack's actual bugs
        run: function run() {
          leaveDetail();
          goTab('issues');
          openIssueDrawer(issue);
        }
      });
    };
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      _loop6();
    }

    // ── Coverage (use-cases, scenarios, invariants, gaps, sources) ──
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  if (coverage) {
    var aspect = coverage.aspects[aspectNames(coverage)[0]];
    var goCoverage = function goCoverage() {
      leaveDetail();
      goTab('coverage');
    };
    var _iterator3 = _createForOfIteratorHelper(coverage.usecases),
      _step3;
    try {
      var _loop3 = function _loop3() {
        var _aspect$usecases$uc$i, _uc$title, _UC_STATUS_PRIORITY;
        var uc = _step3.value;
        var status = aspect === null || aspect === void 0 || (_aspect$usecases$uc$i = aspect.usecases[uc.id]) === null || _aspect$usecases$uc$i === void 0 ? void 0 : _aspect$usecases$uc$i.status;
        items.push({
          id: "uc:".concat(uc.id),
          kind: 'coverage',
          section: 'Coverage',
          label: "Open use-case \xB7 ".concat((_uc$title = uc.title) !== null && _uc$title !== void 0 ? _uc$title : uc.id),
          hint: status !== null && status !== void 0 ? status : 'use-case',
          keywords: "".concat(uc.id, " use case business coverage ").concat(status !== null && status !== void 0 ? status : '', " ").concat(uc.actors.join(' ')),
          priority: (_UC_STATUS_PRIORITY = UC_STATUS_PRIORITY[status !== null && status !== void 0 ? status : '']) !== null && _UC_STATUS_PRIORITY !== void 0 ? _UC_STATUS_PRIORITY : 46,
          run: function run() {
            goCoverage();
            requestCoverageFocus({
              kind: 'usecase',
              ucId: uc.id,
              section: 'scenarios'
            });
          }
        });
        var _iterator6 = _createForOfIteratorHelper(uc.scenarios),
          _step6;
        try {
          var _loop4 = function _loop4() {
            var _sc$intent, _sc$caseType, _sc$caseType2;
            var sc = _step6.value;
            items.push({
              id: "sc:".concat(sc.id),
              kind: 'coverage',
              section: 'Coverage',
              label: "Go to scenario \xB7 ".concat((_sc$intent = sc.intent) !== null && _sc$intent !== void 0 ? _sc$intent : sc.id),
              hint: (_sc$caseType = sc.caseType) !== null && _sc$caseType !== void 0 ? _sc$caseType : 'scenario',
              keywords: "".concat(sc.id, " ").concat(uc.id, " scenario ").concat((_sc$caseType2 = sc.caseType) !== null && _sc$caseType2 !== void 0 ? _sc$caseType2 : ''),
              priority: 36,
              run: function run() {
                goCoverage();
                requestCoverageFocus({
                  kind: 'usecase',
                  ucId: uc.id,
                  section: 'scenarios',
                  scenarioId: sc.id
                });
              }
            });
          };
          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            _loop4();
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
        var _iterator7 = _createForOfIteratorHelper(uc.acceptanceCriteria.filter(isInvariant)),
          _step7;
        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _ac$text;
            var ac = _step7.value;
            items.push({
              id: "inv:".concat(ac.id),
              kind: 'coverage',
              section: 'Coverage',
              label: "Go to invariant \xB7 ".concat((_ac$text = ac.text) !== null && _ac$text !== void 0 ? _ac$text : ac.id),
              hint: 'invariant',
              keywords: "".concat(ac.id, " ").concat(uc.id, " invariant use case wide criteria"),
              priority: 34,
              run: function run() {
                goCoverage();
                requestCoverageFocus({
                  kind: 'usecase',
                  ucId: uc.id,
                  section: 'invariants'
                });
              }
            });
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }
      };
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        _loop3();
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
    var _iterator4 = _createForOfIteratorHelper(coverage.gaps),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var _gap$kind, _gap$question, _gap$kind2;
        var gap = _step4.value;
        items.push({
          id: "gap:".concat(gap.ref, ":").concat((_gap$kind = gap.kind) !== null && _gap$kind !== void 0 ? _gap$kind : ''),
          kind: 'coverage',
          section: 'Coverage',
          label: "Gap \xB7 ".concat((_gap$question = gap.question) !== null && _gap$question !== void 0 ? _gap$question : gap.ref),
          hint: gap.risk ? "".concat(gap.risk, " risk") : 'gap',
          keywords: "gap open question decide ".concat((_gap$kind2 = gap.kind) !== null && _gap$kind2 !== void 0 ? _gap$kind2 : '', " ").concat(gap.ref),
          // The design engine's open questions are attention items — high
          // risk floats near failed tests.
          priority: gap.risk === 'high' ? 68 : 44,
          run: function run() {
            goCoverage();
            requestCoverageFocus({
              kind: 'gaps'
            });
          }
        });
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
    var sources = uniqueSources(coverage.usecases);
    if (sources.length > 0) {
      items.push({
        id: 'action:context-sources',
        kind: 'action',
        section: 'Actions',
        label: "Open Context sources (".concat(sources.length, ")"),
        hint: 'action',
        keywords: 'context sources clarification documents feeding drawer',
        priority: 49,
        run: function run() {
          goCoverage();
          requestCoverageFocus({
            kind: 'context'
          });
        }
      });
      var _iterator5 = _createForOfIteratorHelper(sources),
        _step5;
      try {
        var _loop2 = function _loop2() {
          var _src$mediaType;
          var src = _step5.value;
          if (!src.file) return 1; // continue
          items.push({
            id: "src:".concat(src.id),
            kind: 'action',
            section: 'Actions',
            label: "Download source \xB7 ".concat(src.id),
            hint: 'download',
            keywords: "source blob context ".concat((_src$mediaType = src.mediaType) !== null && _src$mediaType !== void 0 ? _src$mediaType : ''),
            priority: 20,
            run: function run() {
              return void downloadSourceEntry(src.file, src.id);
            }
          });
        };
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          if (_loop2()) continue;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }

  // ── Steps + detail actions (only with an open detail) ──
  if (detail) {
    var _detail$tree$flatStep, _detail$tree;
    var flat = (_detail$tree$flatStep = (_detail$tree = detail.tree) === null || _detail$tree === void 0 ? void 0 : _detail$tree.flatSteps) !== null && _detail$tree$flatStep !== void 0 ? _detail$tree$flatStep : [];
    var failedStep = flat.find(function (s) {
      return s.status === 'failed';
    });
    if (failedStep) {
      var _failedStep$ordinal;
      items.push({
        id: 'action:view-failed-step',
        kind: 'action',
        section: 'Actions',
        label: "View failed step (step ".concat((_failedStep$ordinal = failedStep.ordinal) !== null && _failedStep$ordinal !== void 0 ? _failedStep$ordinal : '?', ")"),
        hint: 'action',
        keywords: 'jump failure error why',
        priority: 95,
        run: function run() {
          return selectDetailStep(failedStep.key);
        }
      });
    }
    flat.forEach(function (step, i) {
      var _step$ordinal, _step$command, _step$kind;
      if (step.orphan) return; // no authored row to jump to
      items.push({
        id: "step:".concat(step.key),
        kind: 'step',
        section: 'Steps',
        label: "Go to step ".concat((_step$ordinal = step.ordinal) !== null && _step$ordinal !== void 0 ? _step$ordinal : i + 1, " \xB7 ").concat(step.title),
        hint: step.status === 'unknown' ? 'step' : step.status,
        status: step.status,
        keywords: "".concat((_step$command = step.command) !== null && _step$command !== void 0 ? _step$command : '', " ").concat((_step$kind = step.kind) !== null && _step$kind !== void 0 ? _step$kind : ''),
        priority: 30,
        run: function run() {
          return selectDetailStep(step.key);
        }
      });
    });
    items.push({
      id: 'action:logs-console',
      kind: 'action',
      section: 'Actions',
      label: 'Open Console logs',
      hint: 'logs',
      keywords: 'browser devtools output',
      priority: 55,
      run: function run() {
        setDetailDrawer(true, 'logs');
        setDetailLogsSub('console');
      }
    }, {
      id: 'action:logs-terminal',
      kind: 'action',
      section: 'Actions',
      label: 'Open Terminal logs',
      hint: 'logs',
      keywords: 'runner run.log cli output',
      priority: 54,
      run: function run() {
        setDetailDrawer(true, 'logs');
        setDetailLogsSub('terminal');
      }
    }, {
      id: 'action:network',
      kind: 'action',
      section: 'Actions',
      label: harRefsFor(detail).length > 0 ? 'Open Network (HAR)' : 'Open Network',
      hint: 'logs',
      keywords: 'har requests waterfall http',
      priority: 53,
      run: function run() {
        return setDetailDrawer(true, 'network');
      }
    }, {
      id: 'action:back',
      kind: 'action',
      section: 'Actions',
      label: 'Back to all test instances',
      hint: 'action',
      keywords: 'close detail list return',
      priority: 50,
      run: function run() {
        return closeDetailWithUrl();
      }
    });
  }

  // ── Global actions ──
  items.push({
    id: 'action:download',
    kind: 'action',
    section: 'Actions',
    label: 'Download evidence pack',
    hint: 'action',
    keywords: '.evidence save export file',
    priority: 60,
    run: function run() {
      return downloadPack();
    }
  }, {
    id: 'action:copy-link',
    kind: 'action',
    section: 'Actions',
    label: 'Copy link to this view',
    hint: 'action',
    keywords: 'share url deep link',
    priority: 48,
    run: function run() {
      if (navigator.clipboard) {
        void navigator.clipboard.writeText(window.location.href);
      }
    }
  });
  return items;
}

/** Query-intent boosts — the "reads your mind" part, kept deterministic. */
var INTENT_BOOSTS = [{
  match: /\bfail/i,
  boost: function boost(i) {
    return i.status === 'failed' ? 60 : 0;
  }
}, {
  match: /\bbroke/i,
  boost: function boost(i) {
    return i.status === 'broken' ? 60 : 0;
  }
}, {
  match: /\bpass/i,
  boost: function boost(i) {
    return i.status === 'passed' ? 60 : 0;
  }
}, {
  match: /\b(log|console|terminal)/i,
  boost: function boost(i) {
    return i.hint === 'logs' ? 40 : 0;
  }
}, {
  match: /\b(network|har|request)/i,
  boost: function boost(i) {
    return i.id === 'action:network' ? 60 : 0;
  }
}, {
  match: /\b(download|save|export)/i,
  boost: function boost(i) {
    return i.id === 'action:download' ? 60 : 0;
  }
}, {
  match: /\b(share|link|copy|permalink)/i,
  boost: function boost(i) {
    return i.id === 'action:copy-link' ? 60 : 0;
  }
}, {
  match: /\b(issue|rca|root cause|bug)/i,
  boost: function boost(i) {
    return i.kind === 'issue' ? 60 : 0;
  }
}, {
  match: /\bstep\b/i,
  boost: function boost(i) {
    return i.kind === 'step' ? 30 : 0;
  }
}, {
  match: /\b(coverage|use ?-?case|uc-)/i,
  boost: function boost(i) {
    return i.id.startsWith('uc:') ? 60 : 0;
  }
}, {
  match: /\b(scenario|sc-)/i,
  boost: function boost(i) {
    return i.id.startsWith('sc:') ? 50 : 0;
  }
}, {
  match: /\binvariant/i,
  boost: function boost(i) {
    return i.id.startsWith('inv:') ? 60 : 0;
  }
}, {
  match: /\bgap\b/i,
  boost: function boost(i) {
    return i.id.startsWith('gap:') ? 60 : 0;
  }
}, {
  match: /\b(source|context)\b/i,
  boost: function boost(i) {
    return i.id.startsWith('src:') || i.id === 'action:context-sources' ? 50 : 0;
  }
}];
var SECTION_ORDER = {
  'Jump to': 0,
  Issues: 1,
  Tests: 2,
  Coverage: 3,
  Steps: 4,
  Actions: 5
};

/**
 * Order items for display. Empty query = the Suggested view: canonical
 * section order, priority-sorted inside each. With a query: fuzzy score +
 * intent boosts + a slice of priority, best match first (flat re-grouping
 * by consecutive section headers happens in the component).
 */
export function rankItems(items, query) {
  var q = query.trim();
  if (q === '') {
    return _toConsumableArray(items).sort(function (a, b) {
      return SECTION_ORDER[a.section] - SECTION_ORDER[b.section] || b.priority - a.priority;
    });
  }
  var scored = [];
  var _iterator8 = _createForOfIteratorHelper(items),
    _step8;
  try {
    for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
      var item = _step8.value;
      var base = fuzzyScore(q, "".concat(item.label, " ").concat(item.keywords));
      if (base === null) continue;
      var score = base + item.priority / 10;
      var _iterator9 = _createForOfIteratorHelper(INTENT_BOOSTS),
        _step9;
      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var rule = _step9.value;
          if (rule.match.test(q)) score += rule.boost(item);
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
      scored.push({
        item: item,
        score: score
      });
    }
  } catch (err) {
    _iterator8.e(err);
  } finally {
    _iterator8.f();
  }
  return scored.sort(function (a, b) {
    return b.score - a.score;
  }).map(function (s) {
    return s.item;
  });
}